import React from 'react'

export const AppBinWarningIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="#FEE6E5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="trash">
        <path
          id="Shape"
          d="M19.6539 12L19.1923 24M12.8077 24L12.3462 12M25.6369 7.72076C26.0928 7.78962 26.5472 7.86329 27 7.94172M25.6369 7.72076L24.2131 26.2301C24.0928 27.7931 22.7895 29 21.2219 29H10.7781C9.21049 29 7.90716 27.7931 7.78693 26.2301L6.36314 7.72076M25.6369 7.72076C24.1083 7.48992 22.562 7.31314 21 7.19243M5 7.94172C5.45277 7.86329 5.90716 7.78962 6.36314 7.72076M6.36314 7.72076C7.8917 7.48992 9.43799 7.31314 11 7.19243M21 7.19243V5.97092C21 4.39843 19.7858 3.08564 18.2141 3.03536C17.479 3.01185 16.7409 3 16 3C15.2591 3 14.521 3.01185 13.7859 3.03536C12.2142 3.08564 11 4.39843 11 5.97092V7.19243M21 7.19243C19.3501 7.06494 17.6826 7 16 7C14.3174 7 12.6499 7.06494 11 7.19243"
          stroke="#EC5962"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
